module.exports = __webpack_public_path__ + "static/img/target-oxbridge.08aab8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/target-oxbridge.png
// module id = Z4pQ
// module chunks = 0